import { Contract01Icon, EllipseIcon, HandShakeIcon } from '@forwardflow/icons'
import { DnDStageGroupDropZone } from '../DnDStageGroupDropZone'
import { useDnDStageMappingContext } from '../../hooks/useDnDStageMappingContext'

interface ActiveStagesTabProps {
   onRemoveStage?: (stageId: string) => void
   onRemoveTag?: (tagId: string) => void
}

export const ActiveStagesTab = ({
   onRemoveStage,
   onRemoveTag,
}: ActiveStagesTabProps) => {
   const { getStagesAndTagsByIdentifier } = useDnDStageMappingContext()
   const { stages: underContractStages, tags: underContractTags } =
      getStagesAndTagsByIdentifier('ff-under-contract')
   const { stages: activeClientStages, tags: activeClientTags } =
      getStagesAndTagsByIdentifier('ff-active-client')
   const { stages: closedClientStages, tags: closedClientTags } =
      getStagesAndTagsByIdentifier('ff-closed-client')

   return (
      <div className="space-y-5">
         <DnDStageGroupDropZone
            isMandatory={true}
            stages={underContractStages}
            tags={underContractTags}
            title="Under Contract"
            id="ff-under-contract"
            key="ff-under-contract"
            description="The buyer's offer has been accepted OR the seller's home has gone under contract. This is the transaction phase: inspections, appraisal, financing, due diligence."
            icon={<Contract01Icon width={24} height={24} />}
            onClose={onRemoveStage}
            onCloseTag={onRemoveTag}
         />
         <DnDStageGroupDropZone
            stages={activeClientStages}
            tags={activeClientTags}
            isMandatory={true}
            icon={<HandShakeIcon width={24} height={24} />}
            title="Active Client"
            id="ff-active-client"
            key="ff-active-client"
            description="The lead is active and is ready to buy or sell a property"
            onClose={onRemoveStage}
            onCloseTag={onRemoveTag}
         />
         <DnDStageGroupDropZone
            stages={closedClientStages}
            tags={closedClientTags}
            icon={<EllipseIcon width={24} height={24} />}
            title="Closed Client"
            id="ff-closed-client"
            key="ff-closed-client"
            description="The lead is closed and is not ready to buy or sell a property"
            onClose={onRemoveStage}
            onCloseTag={onRemoveTag}
         />
      </div>
   )
}
